
import {  SiriusBaseComponent } from 'sirius-framework';
import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { IndividualSalesService } from '../../../inner-menu-sales/inner-menu-sales.service';
import { ValidationService } from '../../../shared/service/validation-service';
import { CommonService } from '../../../shared/service/shared.service';
import { SharedModel } from '../../../shared/models/shared.model';
import { SalesTransactionInformationModel } from '../../../shared/models/salesinformation.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MemberInfo } from '../../../shared/models/shared.model';
import { TransactionNames } from '../../../shared/constants/constants'
import { OwnAccountsComponent } from '../../../popup/own-accounts/own-accounts.component';
import { MessageShowComponent } from '../../../popup/message-show/message-show.component';

declare const $: any;

@Component({
    selector: 'sales-individual',
    templateUrl: './sales-individual.component.html',
    styleUrls: ['./sales-individual.component.css']
})

export class SalesIndividualComponent extends SiriusBaseComponent<any> implements AfterViewInit {

    @ViewChild('SellerIban') sellerIban: any;
    @ViewChild('SellerEmail') sellerEmail: any;
    @ViewChild('Plate') plate: any;
    @ViewChild('SalesAmount') salesAmount: any;
    @ViewChild('BuyerPhone') buyerPhone: ElementRef;
    @ViewChild('ownAccounts') ownAccounts: OwnAccountsComponent;
    @ViewChild('messagePopup') messagePopup: MessageShowComponent;

    salesTransactionInformationItem: SalesTransactionInformationModel = new SalesTransactionInformationModel();
    mernisNo: string;
    pageNumber: number = 0;
    profileEmail: string;
    searchForm: FormGroup;
    branchArray: any[];

    isBuyerPhoneNotValid: boolean = false;
    isPlateValid: boolean = true;
    isIbanValid: boolean = true;
    isEmailValid: boolean = false;
    isAmountValid: boolean = true;
    referenceNumber: string = "0";
    referenceNumberGoi = "0";
    bankName: string;
    formattedIban: string;
    private popUpMessage: string;

    emailNotValid: boolean = false;

    phoneValidation: string;
    commissionAmount: number = 0;
    totalAmount: string;
    totalAmountDec: number;
    amountMinThanCommissionError: string;
    licencePlateError: string;
    confirmMessageFilled: string;
    confirmMessageExtra: string;
    confirmMessage: string;
    confirmMessageComm: string;
    resultMessage: string;
    errorMessage: string;
    sellerIbanMessage: string;
    amountError: string;
    sellerIbanValidationMessage: string;

    showBackToMainButton: boolean = false;
    ownAccountsCheck: boolean = false;

    showConfirmMessageExtraForIban: boolean = false
  confirmMessageExtraForIban: string = 'İşleme devam edebilirsiniz, ancak dikkat etmeniz gereken bir durum tespit edildi. Girilen kimlik numarasına ait ünvan, IBAN doğrulama süreci sonucunda elde edilen ünvanla tam olarak eşleşmemektedir. Bu durum, tescil sonrası yapılacak transfer işleminde gecikmeye veya aksaklığa neden olabilir. Bilgilerinizi lütfen tekrar gözden geçirerek doğru IBAN girdiğinizden emin olunuz. Gerekirse, Geri butonuna basarak önceki adıma dönerek bilgileri güncelleyebilirsiniz.';


    regexPlate = /^(0[1-9]|[1-7][0-9]|8[01])((\s?[a-zA-Z]\s?)(\d{4,5})|(\s?[a-zA-Z]{2}\s?)(\d{3,4})|(\s?[a-zA-Z]{3}\s?)(\d{2,4}))$/;
    maskTel = ['(', /[5]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
    maskIBAN = ['TR', /\d/, /\d/, /\s/, /\d/, /\d/, /\d/, /\d/, /\s/, /\d/, /\d/, /\d/, /\d/, /\s/, /\d/, /\d/, /\d/, /\d/, /\s/, /\d/, /\d/, /\d/, /\d/, /\s/, /\d/, /\d/, /\d/, /\d/, /\s/, /\d/, /\d/];


    private profileInfo: MemberInfo = new MemberInfo(); 

    constructor(private apiService: IndividualSalesService, private validateService: ValidationService,
        private commonService: CommonService) {
        super();
    }

    OnInit() { 
        this.apiService.dataServiceInstance = this.dataService;
        this.validateService.dataServiceInstance = this.dataService;
        this.branchArray = this.commonService.publicEftList.BranchArray;

        let response = this.apiService.getCustomerInfo().toPromise();
        response.then((result) => {
            this.profileInfo = <MemberInfo>result;
            this.profileEmail = this.profileInfo ? this.profileInfo.Email : "";       
            this.ownAccountsCheck = this.profileInfo.HasAcc;               
        });

        this.amountMinThanCommissionError = this.resourceService.getResource("sales_AmountMinThanCommissionError");
        this.licencePlateError = this.resourceService.getResource("sales_LicencePlateError");
        this.confirmMessage = this.resourceService.getResource("sales_ConfirmMessage");
        this.confirmMessageComm = this.resourceService.getResource("sales_ConfirmMessageComm");
        this.resultMessage = this.resourceService.getResource("sales_ResultMessage"); 
        this.errorMessage = this.resourceService.getResource("sales_ErrorMessage"); 
        this.sellerIbanMessage = this.resourceService.getResource("SellerIbanMessage"); 
        this.confirmMessageExtra = this.resourceService.getResource("sales_confirmMessageExtra");
      if (this.confirmMessageExtra == 'generalresource_tr-tr_sales_confirmmessageextra' || this.confirmMessageExtra == '0')
            this.confirmMessageExtra = '';
    }

    private formValidation(): void {
        if (this.pageNumber === 1) {
            if (this.sellerIban && this.sellerIban.value == null && !this.isIbanValid) {
              this.sellerIbanValidationMessage = "IBAN bilgisi zorunludur.";
            }
        }

    }

    ngAfterViewInit() {
        //Sayfa yüklendikten sonra default validasyon mesajları set edilir..
        this.formValidation();
    }

    showPanel(pageIndex: number) {
        $("kendo-maskedtextbox").addClass("form-control");
        $("kendo-numerictextbox").addClass("form-control");
        //$("kendo-numerictextbox").css("font", "400 13.3333px Arial");
        //$("kendo-maskedtextbox").css("font", "400 13.3333px Arial"); 
        $("kendo-numerictextbox").css("font-size", "16px");
        $("kendo-maskedtextbox input").css("font-size", "16px"); 

        if (pageIndex === -1 && this.pageNumber !== 3) //footer
            return true;
        return pageIndex == this.pageNumber
    }

    private ibanValid(event: any): void {   
        let verifyPromise = this.verifyIBAN().toPromise().then((verifyResult) => {
            if (!verifyResult.IsValid) {
                this.isIbanValid = false;
                this.sellerIbanValidationMessage = verifyResult.ResultMessage;
                if (verifyResult.ForceLogOut)
                    this.commonService.logOutClient();
            }
            else {
              this.isIbanValid = true;
              if (verifyResult.ResultMessage != 'OK')
                this.showConfirmMessageExtraForIban = true;
              else
                this.showConfirmMessageExtraForIban = false;
              this.sellerIbanValidationMessage = '';
            }
        } );      
    }

    private phoneValid(event: any): void {
        if (this.salesTransactionInformationItem.BuyerPhone.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").replace(/-/g, "").replace(/\s/g, '') ==
            this.profileInfo.PhoneNumber.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").replace(/-/g, "").replace(/\s/g, '')) {

            this.isBuyerPhoneNotValid = true;
            this.phoneValidation = "Satıcı telefonu girilemez.";
        }

        else if (this.salesTransactionInformationItem.BuyerPhone.replace(/_/g, "").replace(/\s/g, '').length != 14) {
            this.isBuyerPhoneNotValid = true;
            this.phoneValidation = "Alıcı telefonu bilgisi zorunludur.";
        }
        else {
            this.isBuyerPhoneNotValid = false;
            let promise = this.validateService.validatePhonenumber(this.salesTransactionInformationItem.BuyerPhone).toPromise();
            promise.then((result) => {
                this.phoneValidation = "Cep telefonu numarası geçersiz.";
                this.isBuyerPhoneNotValid = !result.IsValid;
            }); 
        }
    }
      
    private verifyIBAN() { 
        return this.validateService.verifyIBAN(this.salesTransactionInformationItem.SellerIban,'','B');
    }

    private getCalculateStpCommission() { 
        return this.apiService.getStpCommission(this.salesTransactionInformationItem.SalesAmount);
    }

    private createStpSeller() {
        return this.apiService.createStpSellerTransaction(this.salesTransactionInformationItem);
    }

    private updateEmail() {
        return this.apiService.updateCustomerInfo(this.profileInfo);
    }

    private controlEmail(event: any): void {

        if (this.profileEmail == null || this.profileEmail == '') {
            this.emailNotValid = false;
            return;
        } 

        if (!this.profileEmail.includes('@') || !this.profileEmail.includes('.')) {
            this.emailNotValid = true;
            return;
        }

        this.emailNotValid = false;
        let promise = this.validateService.validateMail(this.profileEmail).toPromise();
        promise.then((serviceResult) => {
            if (serviceResult.IsValid == false) {
                this.emailNotValid = true; 
            }
        });
  }

  private plateValid(event: any): void {
    if (this.plate && (this.plate.value == undefined || this.plate.value == null || this.plate.value == '')) {
      this.isPlateValid = false;
      this.licencePlateError = "Plaka bilgisi zorunludur.";
    }
    else
    {
      this.isPlateValid = true;
      this.licencePlateError = "";
    }
  }

  private amountValid(event: any): void {
    if (this.salesAmount && (this.salesAmount.value == undefined || this.salesAmount.value == null || this.salesAmount.value == '')) {
      this.isAmountValid = false;
      this.amountError = "Ödenecek tutar bilgisi zorunludur.";
    }
    else {
      this.isAmountValid = true;
      this.amountError = "";
    }
  }

    private formValidationForEmptyFields(): boolean {
        let result = true;
        if (this.sellerIban && (this.sellerIban.value == undefined || this.sellerIban.value == null || this.sellerIban.value == '')) { 
            this.isIbanValid = false;
            this.sellerIbanValidationMessage = "IBAN bilgisi zorunludur.";
            result = false;
        }
        if (this.plate && (this.plate.value == undefined || this.plate.value == null || this.plate.value == '')) { 
          this.isPlateValid = false;
          this.licencePlateError = "Plaka bilgisi zorunludur."; 
            result = false;
        }
        if (this.salesAmount && (this.salesAmount.value == undefined || this.salesAmount.value == null || this.salesAmount.value == '')) { 
          this.isAmountValid = false;
          this.amountError = "Ödenecek tutar bilgisi zorunludur."; 
            result = false;
        }
        
        if (this.buyerPhone && (this.buyerPhone.nativeElement.value == undefined || this.buyerPhone.nativeElement.value == null || this.buyerPhone.nativeElement.value == '')) {
            this.isBuyerPhoneNotValid = true;
            this.phoneValidation = "Alıcı telefonu bilgisi zorunludur.";
            result = false;
        }
        return result;
    }

  nextFunction() {

    if (this.profileInfo.GetName) {
      this.commonService.StartTransaction('AccountProfileTransaction', SharedModel.PageName_Preferences);
      return;
    }
        if (this.pageNumber === 0) {
            if (this.emailNotValid || (this.sellerEmail.errors && (this.sellerEmail.touched || this.sellerEmail.dirty))) {
                return;
            }
            if ((this.profileInfo.Email == "" || this.profileInfo.Email == null || this.profileInfo.Email == undefined) && this.sellerEmail && this.sellerEmail.value != null && this.sellerEmail.value != '') {
                    this.emailNotValid = false;
                    this.profileInfo.Email = this.sellerEmail.value;
                    this.profileInfo.UpdatedFieldInfo = "E";
                    this.updateEmail().toPromise().then((result) => { 
                        
                    }); 
                    this.pageNumber++;
            }
            else {
                this.pageNumber++;

            }
        }
        else if (this.pageNumber === 1) {
            //form empty field validations
            if (!this.formValidationForEmptyFields()) {
                return;
            }

            //IBAN VALIDASYON
            //if (!this.ibanValid())
            //    return false; 

            if (this.salesTransactionInformationItem.SellerIban && this.isIbanValid && this.salesTransactionInformationItem.Plate
                && this.salesTransactionInformationItem.BuyerPhone
                && this.salesTransactionInformationItem.SalesAmount) {

                this.totalAmount = this.salesAmount.value.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " TL"; 
                let bankCode = this.salesTransactionInformationItem.SellerIban.substring(3, 7);
                this.formattedIban = 'TR' + this.salesTransactionInformationItem.SellerIban.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();

              if (this.branchArray != null)
              {
                let branch = this.branchArray.filter(c => c.BankCode == bankCode)[0];

                this.bankName = branch ? branch.BankFriendlyName : "";
                //1 - IBAN VALIDASYONU ONBLUR'DA YAPILDI
              }
               
                //2 - TELEFON NO VALİDASYONU //
                if (this.salesTransactionInformationItem.BuyerPhone.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").replace(/-/g, "").replace(/\s/g, '') ==
                    this.profileInfo.PhoneNumber.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").replace(/-/g, "").replace(/\s/g, '')) {

                    this.isBuyerPhoneNotValid = true;
                  this.phoneValidation = "Satıcı telefonu girilemez.";
                }
                else if (this.salesTransactionInformationItem.BuyerPhone.replace(/_/g, "").replace(/\s/g, '').length != 14) {
                    this.isBuyerPhoneNotValid = true;
                  this.phoneValidation = "Alıcı telefon bilgisi zorunludur.";
                }           


                this.confirmMessageFilled = '';
                this.totalAmountDec = this.salesTransactionInformationItem.SalesAmount;
                // 4- TUTAR VALİDASYONU //
                let promise = this.getCalculateStpCommission().toPromise();
              promise.then((result) => {

                //////////////PhoneValidation//////////
                this.isBuyerPhoneNotValid = false;
                let promise = this.validateService.validatePhonenumber(this.salesTransactionInformationItem.BuyerPhone).toPromise();
                promise.then((result) => {
                  this.phoneValidation = "Cep telefonu numarası geçersiz.";
                  this.isBuyerPhoneNotValid = !result.IsValid;
                });
                //////////////PhoneValidation/////////


                    this.commissionAmount = result.CommissionAmount;

                    if (this.totalAmountDec <= this.commissionAmount) {
                        //this.salesAmount.isValid = false;
                      this.isAmountValid = false;
                      this.amountError = this.amountMinThanCommissionError;
                        //this.salesAmount.errorMessage = this.amountMinThanCommissionError;
                        return;
                    }
                    else { 
                        if (!this.isBuyerPhoneNotValid && this.isPlateValid) {
                            ////////////CONFIRM MESSAGE///////////////////////////////////
                            if (this.commissionAmount == 0) {

                                this.confirmMessageFilled = this.commonService.prepareStringText(this.confirmMessageComm,
                                    [{ key: 'formattedIban', value: this.formattedIban.bold() },
                                    { key: 'bankName', value: this.bankName.bold(), },
                                    { key: 'totalAmount', value: this.totalAmount.bold() }]);
                            }
                            else {
                                this.confirmMessageFilled = this.commonService.prepareStringText(this.confirmMessage,
                                    [{ key: 'formattedIban', value: this.formattedIban.bold() },
                                    { key: 'bankName', value: this.bankName.bold(), },
                                    { key: 'totalAmount', value: this.totalAmount.bold() },
                                    { key: 'commissionAmount', value: (this.commissionAmount.toLocaleString('tr-TR', { style: 'decimal' }) + " TL").bold() }]);
                            }


                            this.pageNumber++;
                        }
                    }
                });
                     
            }
        }
        else {
            this.pageNumber++;
        }
    }

    backFunction() {
        if (this.pageNumber === 1) {
            this.OnInit();
        }
        this.pageNumber--;
    }

    submitFunction() {
        this.salesTransactionInformationItem.CustomerType = "G";

        let response = this.apiService.getCustomerInfo().toPromise();
        response.then((result) => {
            this.profileInfo = <MemberInfo>result;
            this.profileEmail = this.profileInfo ? this.profileInfo.Email : "";
        });


        this.createStpSeller().toPromise().then((result) => {
            this.showBackToMainButton = true;
          this.referenceNumber = result.ResultID;
          this.referenceNumberGoi = result.ResultIDGoi;
            this.errorMessage = result.ResultMessage;
            this.pageNumber++;
            if (result.ResultCode == 10) { 
                setTimeout(() => {
                    this.commonService.logOutClient();
                }, 10000);
            }
        });
    }

    cancelFunction() {
        this.commonService.StartTransaction(TransactionNames.InnerMenuTransaction, SharedModel.PageName_MainInnerPage);
    }

    onCopy() {
        var dummy = document.createElement("textarea");
        document.body.appendChild(dummy);
        dummy.value = this.referenceNumber;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
    
    }

    showOwnAccounts() {
        this.ownAccounts.showPopup();
    }

    onAccountSelect(accNumber: string) {
        let shortedAccNumber = accNumber.substring(2);
        this.sellerIban.value = shortedAccNumber; 
        this.salesTransactionInformationItem.SellerIban = shortedAccNumber;
        this.ibanValid(null);
    }

    showIbanInfo(e: any) {
        this.messagePopup.showCancelButton = false;
        this.popUpMessage = this.sellerIbanMessage;
        this.messagePopup.showPopup();
        e.preventDefault();

  }

  showAmountInfo(e: any) {
    this.messagePopup.showCancelButton = false;
    this.popUpMessage = 'QNB Güvenli Ödeme Sistemi ile sadece araç satış bedelinin nakit ödenecek kısmı ile işlem yapılabilir. Hesabınıza transfer edilmesini beklediğiniz tutarı giriniz.';
    this.messagePopup.showPopup();
    e.preventDefault();
  }

    phoneMaskValid(e: any) {
        if (this.buyerPhone.nativeElement.classList.contains('ng-valid')) {
            this.isBuyerPhoneNotValid = false; 
        }
        else {
          this.isBuyerPhoneNotValid = true;
          this.phoneValidation = "Alıcı telefonu bilgisi zorunludur.";
        }
    }

  onMessageAccepted() {

  }
}
